module.exports = __webpack_public_path__ + "img/3.12f04752.png";